export default __webpack_public_path__ + "static/media/project-img-6.20deb60f.jpg";